/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Refineexamplefilmlookprompt4Inputs */

const en_refineexamplefilmlookprompt4 = /** @type {(inputs: Refineexamplefilmlookprompt4Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Give it a film photo look with fine grain`)
};

const de_refineexamplefilmlookprompt4 = /** @type {(inputs: Refineexamplefilmlookprompt4Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Gib dem Bild einen Filmfoto-Look mit feinem Korn`)
};

/**
* | output |
* | --- |
* | "Give it a film photo look with fine grain" |
*
* @param {Refineexamplefilmlookprompt4Inputs} inputs
* @param {{ locale?: "en" | "de" }} options
* @returns {LocalizedString}
*/
const refineexamplefilmlookprompt4 = /** @type {((inputs?: Refineexamplefilmlookprompt4Inputs, options?: { locale?: "en" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Refineexamplefilmlookprompt4Inputs, { locale?: "en" | "de" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_refineexamplefilmlookprompt4(inputs)
	return de_refineexamplefilmlookprompt4(inputs)
});
export { refineexamplefilmlookprompt4 as "refineExampleFilmLookPrompt" }